import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import CallBadgeWithTime from 'flow/components/ui-components/CallBadgeWithTime';

interface Props {
    number: number;
    joinTime?: string;
}

const QueuePositionWithTime = ({ number, joinTime }: Props) => {
    const { i18next } = useAppContext();

    return (
        <CallBadgeWithTime
            badge={number}
            since={joinTime}
            label={i18next.t('tickets.list.queue_position')}
            timeLabel={i18next.t('tickets.list.wait_time')}
        />
    );
};

export default QueuePositionWithTime;
